import React, { useState, useEffect } from 'react'
import { PostData, fetchData } from '../Services/httpHandelars'
import Dropdown from '../Components/Dropdown';
import { useGlobalContext } from '../context'
import Loader from '../Components/Loader';
import Snackbar from '../Components/Snackbar';
import { useNavigate } from 'react-router-dom';


export const ControlSetup = () => {


    const [form, setForm] = useState({ _id: "", controlName: "", meanValue: "", standardDeviationValue: "", analyzerName: "",upperRange: "",lowerRange:"",assayName:"",lotNo:""})
    const [controlSetup, setControlSetup] = useState([])
    const [AssayName, setAssayName] = useState([]);
    const [snacBar, setSnacBar] = useState({ snacStatus: false, message: "", snackType: "" })

    const { setLoading, loading, setUser } = useGlobalContext();
    const navigate = useNavigate();

    useEffect(
        () => {
            if (snacBar.snacStatus === true) {
                setTimeout(() => setSnacBar(false), 3000);
            }
        },

        [snacBar.snacStatus]
    );

    useEffect(() => {
        fetchData("/api/getControlSetup").then((success) => {
            success = JSON.parse(success)
            if(!success.status && success.message.includes("jwt")){
                setUser(null)
                navigate('/Login')
            }
            else if (success.status){
                const controlSetup = success.data;
                setControlSetup(controlSetup);
            }
        })
        fetchData("/api/getAssaySetup").then((data) => {
            data = JSON.parse(data)
            const Assay = data.data;
            const Name = Assay.map(name=>name?.AssayName)
            setAssayName(Name)
          }).catch(e => console.log(e));
    }, [])



    const HandleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value })
    }

    const handleEditButton = (id) => {
        const editControlSetup = controlSetup.find(cSetup => cSetup._id === id)
        setForm({
            ...form, _id: editControlSetup._id, controlName: editControlSetup.ControlName, meanValue: editControlSetup.MeanValue,
            analyzerName: editControlSetup.AnalyzerName, standardDeviationValue: editControlSetup.StandardDeviationValue,
            upperRange: editControlSetup.UpperRange, lowerRange: editControlSetup.LowerRange, assayName: editControlSetup.AssayName,
            lotNo: editControlSetup.LotNo,
        });
    }

    console.log(controlSetup, " -----44")

    const handleSubmit = () => {
        setLoading(true)
        if (form.controlName  && form.meanValue && form.standardDeviationValue 
            && form.assayName && form.upperRange && form.lowerRange  && form.lotNo){
        if (form._id) {
            const update = {
                controlName: form.controlName.trim(),
                meanValue: form.meanValue,
                standardDeviationValue: form.standardDeviationValue,
                analyzerName: form.analyzerName,
                upperRange: form.upperRange,
                lowerRange: form.lowerRange,
                assayName: form.assayName,
                LotNo: form.lotNo,
                _id: form._id
            }
            

            PostData("/api/updateControlSetup", update).then((success) => {
                setLoading(false)
                if (success.status === true) {
                    setForm({})
                    setSnacBar({
                        ...snacBar,
                        snacStatus: success.status,
                        message: success.message,
                        snackType: "Success"
                    })
                } else {
                    setLoading(false)

                    setSnacBar({
                        ...snacBar,
                        snacStatus: success.status,
                        message: "Responce Failed",
                        snackType: "Error"
                    })
                }
                fetchData("/api/getControlSetup").then((success) => {
                    success = JSON.parse(success)
                    const updateControlSetup = success.data
                    setControlSetup(updateControlSetup)
                })
            }).catch((err) => {
                setLoading(false)

                console.log("asd--->", err)
                setSnacBar({
                    ...snacBar,
                    snacStatus: true,
                    message: "Responce Failed",
                    snackType: "Error"
                })
            })
        }
        else {
                const data = {
                    controlName: form.controlName.trim(),
                    meanValue: form.meanValue,
                    standardDeviationValue: form.standardDeviationValue,
                    analyzerName: form.analyzerName,
                    upperRange: form.upperRange,
                    lowerRange: form.lowerRange,
                    assayName: form.assayName,
                    LotNo: form.lotNo,
                            }
                setForm({})
    
                PostData("/api/saveControlSetup", data).then((success) => {
                    setLoading(false)
                    console.log(success, "----104")
                    if (success.status === true) {
                        setSnacBar({
                            ...snacBar,
                            snacStatus: success.status,
                            message: success.message,
                            snackType: "Success"
                        })
                        let controlSetupData = controlSetup;
                        controlSetupData.push(success.success)
                        setControlSetup(controlSetupData)
                    } else {
                        setLoading(false)
    
                        setSnacBar({
                            ...snacBar,
                            snacStatus: success.status,
                            message: "Responce Failed",
                            snackType: "Error"
                        })
                    }
                    // fetchData("/api/getControlSetup").then((success) => {
                    //     const controlSetup = JSON.parse(success)
                    //     setControlSetup(controlSetup)
                    // })
                }).catch((err) => {
                    setLoading(false)
    
                    console.log("asd--->", err)
                    setSnacBar({
                        ...snacBar,
                        snacStatus: true,
                        message: "Responce Failed",
                        snackType: "Error"
                    })
                })
        }
    }
    else {
        setLoading(false)
        setSnacBar({
            ...snacBar,
            snacStatus: true,
            message: "Kindly fill all the fields",
            snackType: "Error"
        })
    }
    }

    return (
        <>
        {!loading ? <>
            <div>
                <div className='grid justify-center font-medium py-4 text-gray-700'>
                    Control Setup
                </div>
                <div className='shadow overflow-hidden sm:rounded-md mt-5 '>
                    <div className='px-4 py-10 bg-white sm:p-6'>
                        <div className="grid grid-cols-4 gap-4 py-6 px-12 ">
                            <div className="col-span-1">
                                <label htmlFor="controlName" className="block text-sm font-medium text-gray-700">
                                    Control Name
                                </label>
                                <input
                                    type="text"
                                    name="controlName"
                                    value={form.controlName}
                                    onChange={HandleChange}
                                    id="controlName"
                                    autoComplete="given-name"
                                    className="block w-full px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                                />
                            </div>


                            <div className="col-span-1">
                                <label htmlFor="meanValue" className="block text-sm font-medium text-gray-700">
                                    Mean Value
                                </label>
                                <input
                                    type="number"
                                    name="meanValue"
                                    id="meanValue"
                                    value={form.meanValue}
                                    onChange={HandleChange}
                                    autoComplete="given-name"
                                    className="form-control block w-full px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                                />
                            </div>

                            <div className="col-span-1">
                                <label htmlFor="standardDeviationValue" className="block text-sm font-medium text-gray-700">
                                    Standard Deviation
                                </label>
                                <input
                                    type="number"
                                    name="standardDeviationValue"
                                    id="standardDeviationValue"
                                    value={form.standardDeviationValue}
                                    onChange={HandleChange}
                                    autoComplete="given-name"
                                    className="form-control block w-full px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                                />
                            </div>
                            <div className="col-span-1">
                                <label htmlFor="upperRange" className="block text-sm font-medium text-gray-700">
                                    Upper Range
                                </label>
                                <input
                                    type="number"
                                    name="upperRange"
                                    id="upperRange"
                                    value={form.upperRange}
                                    onChange={HandleChange}
                                    autoComplete="given-name"
                                    className="form-control block w-full px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                                />
                            </div>
                            <div className="col-span-1">
                                <label htmlFor="lowerRange" className="block text-sm font-medium text-gray-700">
                                    Lower Range
                                </label>
                                <input
                                    type="number"
                                    name="lowerRange"
                                    id="lowerRange"
                                    value={form.lowerRange}
                                    onChange={HandleChange}
                                    autoComplete="given-name"
                                    className="form-control block w-full px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                                />
                            </div>
                            <div className="col-span-1">
                                <label htmlFor="assayName" className="block text-sm font-medium text-gray-700">
                                    Assay Name
                                </label>
                            <select
                                type="text"
                                name="assayName"
                                title={"Assay Name"} 
                                id="AssayName"
                                value={form.assayName}
                                onChange={HandleChange}
                                autoComplete="given-name"
                                className="form-control block w-full px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                            >
                                <option defaultValue >Select Assay</option>
                                {AssayName.map((assay)=>
                                <option>{assay}</option>
                                )}
                                
                            </select>
                            </div>
                            <div className="col-span-1">
                                <label htmlFor="lotNo" className="block text-sm font-medium text-gray-700">
                                    Lot No
                                </label>
                                <input
                                    type="text"
                                    name="lotNo"
                                    value={form.lotNo}
                                    onChange={HandleChange}
                                    id="lotNo"
                                    autoComplete="given-name"
                                    className="block w-full px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                                />
                            </div>
                        </div>
                        <div className='grid justify-center'>
                            <button
                                onClick={handleSubmit}
                                type='submit'
                                className='py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-green-600 hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500'
                            >
                                {form._id ? "Update" : "Save"}
                            </button>
                        </div>
                    </div>
                </div>

                <div className='flex justify-center'>
                    <table className="w-9/12 text-sm text-center text-gray-500 dark:text-gray-400 mt-20">
                        <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                            <tr>
                                <th scope="col" className="py-3 px-6">
                                    Control Name
                                </th>
                                
                                <th scope="col" className="py-3 px-6">
                                    Mean Value
                                </th>
                                <th scope="col" className="py-3 px-6">
                                    Standard Deviation
                                </th>
                                <th scope="col" className="py-3 px-6">
                                    Upper Range
                                </th>
                                <th scope="col" className="py-3 px-6">
                                    Lower Range
                                </th>
                                <th scope="col" className="py-3 px-6">
                                    Assay Name
                                </th>
                                <th scope="col" className="py-3 px-6">
                                    Lot No
                                </th>
                                <th scope="col" className="py-3 px-6">
                                    Action
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                controlSetup?.map(cSetup => (
                                    <tr key={cSetup._id} className="bg-white border-b dark:border-gray-700 text-gray-700 font-medium h-12">
                                        <>
                                            <td className='px-6'>{cSetup.ControlName}</td>
                                            <td className='px-6'>{cSetup.MeanValue}</td>
                                            <td className='px-6'>{cSetup.StandardDeviationValue}</td>
                                            <td className='px-6'>{cSetup.UpperRange}</td>
                                            <td className='px-6'>{cSetup.LowerRange}</td>
                                            <td className='px-6'>{cSetup.AssayName}</td>
                                            <td className='px-6'>{cSetup.LotNo}</td>
                                            <td className='px-6'><button onClick={() => handleEditButton(cSetup._id)} className='group relative py-1 px-3 border border-transparent text-sm font-medium rounded-md text-white bg-green-600 hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500'>Edit</button></td>
                                        </>
                                    </tr>
                                )
                                )
                            }
                        </tbody>
                    </table>
                </div>
            </div>
            {snacBar?.snacStatus &&
                <Snackbar snackType={snacBar?.snackType} message={snacBar.message} status={snacBar?.snacStatus} setSnacBar={setSnacBar}/>
            }
        </>
            : <Loader />
}
        </>
    )
}
